export { default, getServerSideProps } from "app/compare/[match]";
